var stCustomAddToCart = function (id) {
  let date = new Date();
  let baseUrl = "https://www.mulmul.com";
  let url = `${baseUrl}/cart/add.js`;
  let url1 = `${baseUrl}/cart?view=drawer&timestamp=` + date.getTime();
  let url2 = `${baseUrl}/cart.js`;
  let variant_id = id;
  let form = document.getElementById(
    `quick-add-template--19677189734706__product-grid${id}`
  );
  let cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  let formData = new FormData();
  formData.append("form_type", "product");
  formData.append("utf8", "✓");
  formData.append("id", id);
  // formData.append("sections", "cart-drawer,cart-icon-bubble");
  // formData.append("sections_url", "/variants/"+ id);
  // if (cart) {
  //   formData.append(
  //     "sections",
  //     "cart-notification-product,cart-notification-button,cart-icon-bubble"
  //   );
  //   formData.append("sections_url", window.location.pathname);
  // }
  fetch(url, {
    method: "POST",
    headers: {
      Accept: "*/*",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: formData,
  })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .then((response) => {
  const cartDotElement = document.querySelector(".header__cart-dot");
  if (!cartDotElement.classList.contains("is-visible")) {
    cartDotElement.classList.add("is-visible");
  }

      // window.HsCartDrawer.updateSlideCart();
      // let cart_dot = document.querySelector(".cart-count-bubble");
      // if (cart_dot) {
      //   cart_dot.click();
      // } else {
      //   setTimeout(() => {
      //     cart_dot = document.querySelector(".cart-count-bubble");
      //     if (cart_dot) cart_dot.click();
      //   }, 1500);
      // }
      // let obj = new CartNotification();
      // obj.renderContents(response);
      // var xhr1 = new XMLHttpRequest();
      // xhr1.onreadystatechange = function () {
      //   if (this.readyState === 4 && this.status === 200) {
      //     // _this.updateCart(xhr1.responseText);
      //   }
      // };
      // xhr1.open("GET", url1, true);
      // xhr1.send(null);
      // fetch(url2)
      //   .then((response) => response.json())
      //   .then((x) => {
      //     let cart_dot = document.querySelector(".cart-link__bubble");
      //     let cart_dot_num = document.querySelector(".cart-link__bubble-num");
      //     if (cart_dot && cart_dot_num) {
      //       cart_dot.classList.add("cart-link__bubble--visible");
      //       cart_dot_num.innerHTML = x.item_count;
      //       cart_dot.click();
      //     }
      //   });
    });
};
